import { Helmet, HelmetProvider } from '@dr.pogodin/react-helmet';

export default function Seo({ title, description, path = '/' }) {
  const url = `https://onlinegrowthclub.nl${path}`;
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description,
    url,
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
